import { IModColorBgText, IModOrientation } from '@ucheba/utils/helpers/styles/mod.types'
import {
  IPropChildren,
  IPropDescription,
  IPropSubtitle,
  IPropTitle,
} from '@ucheba/utils/helpers/components/prop.types'
import { IPropBoxSpacing } from '../Box/types'
import { IHeadingProps } from '../Heading/types'

export interface IPromoBlockProps
  extends IPropChildren,
    IPropBoxSpacing,
    IModOrientation,
    IModImgView,
    IModColorBgText,
    IPropTitle,
    IPropSubtitle,
    IPropDescription,
    Pick<IHeadingProps, 'StartIcon' | 'iconBreak' | 'iconSpacing'> {}

export enum EModImgView {
  candidates = 'imgView=candidates',
  schoolGirl = 'imgView=schoolGirl',
  selectVuzChildren = 'imgView=selectVuzChildren',
  computerAndBooks = 'imgView=computerAndBooks',
  girlWithPhone = 'imgView=girlWithPhone',
  consultationBoy = 'imgView=consultationBoy',
}

export interface IModImgView {
  /** Вид изобраения */
  imgView?: keyof typeof EModImgView
}

export interface IGetHeadingOptions {
  (
    title: string,
    subtitle: string
  ): {
    h2: string
    h3?: string
  }
}

export interface IPropPromoBlockImage extends IModImgView {}
